import { gql } from '@apollo/client';

export const RestoreClient = gql`
mutation RestoreClient($idClient: ID) {
  restoreClient(idClient: $idClient) {
    status
  }
}
`;